import { render } from "./HolidayCreateEditModal.vue?vue&type=template&id=161cf9ba"
import script from "./HolidayCreateEditModal.vue?vue&type=script&lang=js"
export * from "./HolidayCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__